import { Grid, GridParams, GridOptions, createGrid, GridApi } from 'ag-grid-community';

export function initialiseAgGridWithAngular1(angular: any) {
    const angularModule = angular.module("agGrid", []);
    angularModule.directive("agGrid", function() {
        return {
            restrict: "A",
            controller: ['$element', '$scope', '$compile', '$attrs', AngularDirectiveController],
            scope: true
        };
    });
}

function AngularDirectiveController($element: any, $scope: any, $compile: any, $attrs: any) {
    let gridOptions: GridOptions;

    const keyOfGridInScope = $attrs.agGrid;
    gridOptions = $scope.$eval(keyOfGridInScope);
    if (!gridOptions) {
        console.warn("WARNING - grid options for AG Grid not found. Please ensure the attribute ag-grid points to a valid object on the scope");
        return;
    }

    const eGridDiv = $element[0];
    let gridApi: GridApi | null = createGrid(eGridDiv, gridOptions);

    const quickFilterOnScope = keyOfGridInScope + '.quickFilterText';
    const quickFilterUnregisterFn = $scope.$watch(
        quickFilterOnScope,
        (newFilter: any) => {
            gridApi!.setGridOption('quickFilterText', newFilter)
        }
    );

    $scope.$on("$destroy", function() {
        quickFilterUnregisterFn();
        if (gridApi) {
            gridApi.destroy();
        }
        gridApi = null;
    });
}